<div *ngIf="selecionado">
  <app-bonificacao-cadastro
    [model]="selecionado"
    (buscar)="buscar($event)"
    [state]="state">
  </app-bonificacao-cadastro>
</div>
<div *ngIf="!selecionado">
  <app-bonificacao-filtro [filtros]="filtros"></app-bonificacao-filtro>
  <app-bonificacao-lista
    [filtros]="filtros"
    (exibir)="selecionar($event)"
    (definirFiltro)="definirFiltro()">
  </app-bonificacao-lista>
</div>